import { Button, Tooltip } from "@mantine/core";
import React from "react";
import { useLocalStorage } from "usehooks-ts";

const ToggleTextExpand: React.FC<any> = ({ currentApp }) => {
  const [globalHidden, setGlobalHidden] = useLocalStorage(`collapseCell${currentApp}`, true);
  const handleClick = (event) => {
    setGlobalHidden(!globalHidden);
  };
  return (
    <>
      <Tooltip withArrow label={"Utvid/kollaps celler"} offset={2} openDelay={200}>
        <Button
          color={"mc-primary"}
          px="sm"
          variant="light"
          size="sm"
          onClick={(e) => handleClick(e)}
          id="ToggleTextExpand"
        >
          {globalHidden ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              fill="currentColor"
              className="bi bi-arrows-expand"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10z"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              fill="currentColor"
              className="bi bi-arrows-collapse"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zm7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0zm-.5 11.707-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0v-3.793z"
              />
            </svg>
          )}
        </Button>
      </Tooltip>
    </>
  );
};
export default ToggleTextExpand;
